<template>
  <div class="inspectionShipment">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="inspectionShipment.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1400px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          style="position: relative"
          :model="inspectionShipment"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="first">
            <el-row>
              <el-col :span="8">
                <el-form-item label="检验员：">
                  <el-input v-model="inspectionShipment.inspectorName" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="检验时间：">
                  <el-input v-model="inspectionShipment.createdTime" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出厂编号：">
                  <el-input v-model="inspectionShipment.factoryNo"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="客户名称" prop="customerName">
                  <el-input v-model="inspectionShipment.customerName" placeholder="请输入" clearable>
                    <el-button
                        slot="append"
                        icon="el-icon-search"
                        style="margin-left: 2%;"
                        @click="$refs.selectCustomer.open()">
                      选择
                    </el-button>
                  </el-input>
                  <customer-select ref="selectCustomer" @select="selectCustomer"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发运单号：">
                  <el-input v-model="inspectionShipment.deliveryNo"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发运日期：">
                  <el-date-picker
                      v-model="inspectionShipment.deliveryDate"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="date"
                      placeholder="选择日期"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="基准：">
                  <el-input v-model="inspectionShipment.standards"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="实际：">
                  <el-input v-model="inspectionShipment.practical"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="问题分类：">
                  <el-select
                      v-model.trim="inspectionShipment.problemClassification"
                      clearable
                      placeholder="请选择">
                    <el-option
                        v-for="item in constants.problemClassification_LL.$options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                  <el-select
                      v-if="inspectionShipment.storageInspectionType === 20"
                      v-model.trim="inspectionShipment.problemClassification"
                      clearable
                      placeholder="请选择">
                    <el-option
                        v-for="item in constants.problemClassification_RJ.$options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="物料号：">
                  <el-input v-model="inspectionShipment.materialNo"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="当批总数：">
                  <el-input v-model="inspectionShipment.batchAllNum" min="1" type="number"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="检查总数：">
                  <el-input v-model="inspectionShipment.checkAllNum" min="1" type="number"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="问题初步调查：">
                  <el-input v-model="inspectionShipment.preliminaryInvestigation" type="textarea"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="实际不良总数：" :span="8">
                  <el-input v-model="inspectionShipment.badQuality" type="number" min="1"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="是否处理：">
                  <el-radio-group v-model="inspectionShipment.needHandle">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="区域负责工程师：">
                  <el-input v-model="inspectionShipment.regionalManager" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectRegionalManager.open()"/>
                  </el-input>
                  <user-select ref="selectRegionalManager" @select="selectRegionalManager"/>
                </el-form-item>
              </el-col>
              <el-col v-if="inspectionShipment.needHandle" :span="8">
                <el-form-item label="处理人：">
                  <el-input v-model="inspectionShipment.handleName" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectHandle.open()"/>
                  </el-input>
                  <user-select ref="selectHandle" @select="onSelectHandle"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="责任部门接口人：">
                  <el-input v-model="inspectionShipment.responsibleName" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectResponsibleName.open()"/>
                  </el-input>
                  <user-select ref="selectResponsibleName" @select="onSelectResponsibleName"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="责任部门：">
                  <el-input v-model="inspectionShipment.responsibleDepartment"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="检验结果：">
                  <el-radio-group v-model="inspectionShipment.inspectionResult">
                    <el-radio :label="true">ok</el-radio>
                    <el-radio :label="false">ng</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <!--            <el-form-item label="检验项目">-->
            <!--              <el-checkbox-group v-model="inspectionShipment.inspectionDetailVOS">-->
            <!--                <el-checkbox v-for="item in inspectionShipment.inspectionTemplateDetailVOS" :key="item.pkid" :label="item.inspectionName">{{item.inspectionName}}</el-checkbox>-->
            <!--              </el-checkbox-group>-->
            <!--            </el-form-item>-->
          </el-tab-pane>
          <el-tab-pane v-if="inspectionShipment.pkid > 0" label="工作流详情" name="third">
            <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
        <el-button :loading="submitLoading" type="primary" @click="save()">保存</el-button>
        <el-button
            :disabled="inspectionShipment.status === 10"
            :loading="submitLoading"
            type="primary"
            @click="submit()">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import auth from "@/util/loginUtil";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";

  export default {
    name: "InspectionShipmentEdit",
    components: {
      UserSelect,
      CustomerSelect, HandleDetail},
    data() {
      return {
        constant,
        constants,
        editAuth: this.$auth(832),
        uploadLoading: false,
        billId: "0",
        billType: "23",
        handleType: constant.toSelect(constant.handleType),
        exportLoading: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        saveLoading: false,
        activeName: "first",
        value: "",
        inspectionShipment: {
          pkid: 0,
          billNo: "",
          voucherNo: "",
          factoryNo: "",
          purchaseOrderNo: "",
          regionalManager: "",
          handleName: "",
          responsibleName: "",
          deliveryNo: "",
          deliveryDate: "",
          customerId: "",
          customerName: "",
          status: 0,
          inspectorName: auth.getName(),
          checkAllNum: 0,
          batchAllNum: 0,
          inspectionTemplateDetailVOS:[],
        },
        ruleValidate: {
          regionalManager: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.inspectionShipment.pkid = id;
        this.billId = id + "";
        this.dialogVisible = true;
        if (this.inspectionShipment.pkid > 0) {
          this.getData();
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `inspectionShipments/${this.inspectionShipment.pkid}`)
          .then(resp => {
            console.log(resp);
            this.inspectionShipment = resp;
            this.contentLoading = false;
          });
      },
      selectRegionalManager(row) {
        console.log(row);
        this.inspectionShipment.regionalID = row.systemUserID;
        this.inspectionShipment.regionalManager = row.employeeName;
      },
      onSelectResponsibleName(row) {
        this.inspectionShipment.responsibleID = row.systemUserID;
        this.inspectionShipment.responsibleName = row.employeeName;
        this.inspectionShipment.responsibleDepartment = row.departmentName;
      },
      onSelectHandle(row) {
        this.inspectionShipment.handleID = row.systemUserID;
        this.inspectionShipment.handleName = row.employeeName;
      },
      selectCustomer(row) {
        console.log(row);
        this.inspectionShipment.customerName = row.customerName;
        this.inspectionShipment.customerId = row.customerID;
      },
      changeInspectionResult(row) {
        console.log(row.inspectionResult);
        if (!row.inspectionResult) {
          this.$refs.editShipmentDetail.open(row);
        }
      },
      onSelectCustomer(row) {
        this.inspectionShipment.customerId = row.pkid;
        this.inspectionShipment.customerName = row.name;
      },
      insert_submit(isSubmit) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.saveLoading = true;
            this.$http
              .post("basic", `inspectionShipments/insert_submit/${isSubmit}`, this.inspectionShipment)
              .then(() => {
                this.saveLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.saveLoading = false;
              });
          }
        });
      },
      update_submit(isSubmit) {
        console.log(this.inspectionShipment);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", `inspectionShipments/update_submit/${isSubmit}`, this.inspectionShipment)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("操作成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      //保存
      save() {
        if (this.inspectionShipment.pkid>0) {
          this.update_submit(false);
        }else {
          this.insert_submit(false);
        }
      },

      //提交
      submit() {
        if (this.inspectionShipment.pkid>0) {
          this.update_submit(true);
        }else {
          this.insert_submit(true);
        }
      },
      onPictureList(index,row) {
        console.log(index,row);
      },
    },
  };
</script>

<style lang="scss">
  .inspectionShipment {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }

</style>
